import React from 'react';
import './service.css';

const Service = () => {
  return (
    <div className= 'service-container'>
      <span id = 'service'></span>
      <h1>our services</h1>
      <div className = 'ser-contents'>
        <div className='ser-one'>
          <div>
            <i className="fas fa-chalkboard-teacher service-icon"></i>
            <div className='ser-text'>
              <ul>
                <li><p><i className="fas fa-check"></i>WIP</p></li>
                <li><p><i className="fas fa-check"></i>WIP</p></li>
                <li><p><i className="fas fa-check"></i>WIP</p></li>
              </ul>
            </div>
          </div>
        </div>
        <div className='ser-two'>
          <div>
            <i className="fas fa-handshake service-icon"></i>
            <div className='ser-text'>
              <ul>
                <li><p><i className="fas fa-check"></i>WIP</p></li>
                <li><p><i className="fas fa-check"></i>WIP</p></li>
                <li><p><i className="fas fa-check"></i>WIP</p></li>
              </ul>
            </div>
          </div>
        </div>
        <div className='ser-three'>
          <div>
            <i className="fas fa-award service-icon service-icon-certificate"></i>
            <div className='ser-text'>
              <ul>
                <li><p><i className="fas fa-check"></i>WIP</p></li>
                <li><p><i className="fas fa-check"></i>WIP</p></li>
                <li><p><i className="fas fa-check"></i>WIP</p></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Service;